export default __webpack_public_path__ + "static/media/addpolicy.ae24028a.svg";